import { render, staticRenderFns } from "./BotPanel.vue?vue&type=template&id=55e7ddff"
import script from "./BotPanel.vue?vue&type=script&lang=js"
export * from "./BotPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports